import React, { Fragment } from 'react'

const FrontEndDev = () => {
    return (
        <Fragment>
            <h2>Front End Development</h2>
            <p>
                Our process to creating a great frontend is focusing on a
                seamless a user experience. We use the latest technologies in
                web development to produce innovating solutions and next level
                designs. The technical stack we use is similar to the
                technologies used for fortune 500 companies such as Facebook,
                Instagram, Netflix, and the New York Times. We also integrate
                tools that make it easy for small businesses that may not have
                access to a development team, allowing business owners to have
                full control of over their content and message for their
                consumers.
            </p>
            <div className="frontEnd__lists">
                <div className="frontEnd__listSection">
                    <h3>Programing Languages</h3>
                    <ul>
                        <li>JavaScript</li>
                        <li>TypeScript</li>
                    </ul>
                </div>
                <div className="frontEnd__listSection">
                    <h3>Frameworks and Libraries</h3>
                    <ul>
                        <li>Gatsby</li>
                        <li>Next.Js</li>
                        <li>React.Js</li>
                    </ul>
                </div>
                <div className="frontEnd__listSection">
                    <h3>Content Management Systems</h3>
                    <ul>
                        <li>Wordpress</li>
                        <li>Strapi</li>
                    </ul>
                </div>
            </div>
        </Fragment>
    )
}

export default FrontEndDev
